import { createFileRoute } from "@tanstack/react-router";
import {
  BillingTodoGuard,
  BillingTodoPage,
} from "@/features/office/billing/todo";

export const routeId = "/office/billing/todo";

export const Route = createFileRoute("/office/billing/todo")({
  component: BillingTodoRoute,
});

/** Permission guarded: the billing or the approver permission, never the gate. */
function BillingTodoRoute() {
  return (
    <BillingTodoGuard>
      <BillingTodoPage />
    </BillingTodoGuard>
  );
}
